import { render, staticRenderFns } from "./RequiredText.vue?vue&type=template&id=7ed3d113&"
import script from "./RequiredText.vue?vue&type=script&lang=js&"
export * from "./RequiredText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/toshiya.murasaki/Docker/Laravel/TRIPLE-CROWN/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed3d113')) {
      api.createRecord('7ed3d113', component.options)
    } else {
      api.reload('7ed3d113', component.options)
    }
    module.hot.accept("./RequiredText.vue?vue&type=template&id=7ed3d113&", function () {
      api.rerender('7ed3d113', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/member/common/Atoms/RequiredText.vue"
export default component.exports